let QueryParamsUtils = {};

QueryParamsUtils.toQueryParams = (hash) => {
  
  let params = Object.keys(hash)
  .filter((key) => hash[key] !== undefined && hash[key] !== null && hash[key] !== false && !(typeof(hash[key]) && hash[key].length === 0))
  .reduce((a,k) => {
    if (hash[k] instanceof Array) {
      hash[k].forEach((value) => a.push(k+'='+encodeURIComponent(value)))
    } else {
      a.push(k+'='+encodeURIComponent(hash[k]));
    }
    return a;
  },[])
  .join('&');

  return '?' + params;
};

module.exports = QueryParamsUtils;


// WEBPACK FOOTER //
// ./src/js/services/QueryParamsUtils.js